import { useState, type FC } from 'react';
import { Grid } from '@packages/shared';
import { ProductGrid } from '@packages/search/src/components/ProductGrid';
import type { ProductGridProps } from '@packages/search/src/components/ProductGrid';

export type InfiniteProductGridProps = Pick<
  ProductGridProps,
  | 'topLevelCategories'
  | 'displayMode'
  | 'criteoData'
  | 'categoryDataForTracking'
  | 'pageType'
  | 'pageTitle'
  | 'count'
  | 'sortType'
  | 'selectedFilters'
  | 'alternativeQuery'
  | 'resultFallbackType'
> & {
  pageSize?: number;
};

export const InfiniteProductGrid: FC<InfiniteProductGridProps> = (props) => {
  const { pageSize = 72, ...productGridProps } = props;
  const [pagesToDisplay, setPagesToDisplay] = useState(1);

  return (
    <>
      {Array.from({ length: pagesToDisplay }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Grid key={`page-${i}`} container>
          <Grid sx={{ marginTop: 2.5 }} item>
            <ProductGrid
              onFirstBecameVisible={(index = 0) => {
                // load next page when 70% of the current page is visible
                if (index + 1 >= 0.7 * pageSize) {
                  setPagesToDisplay((previous) => Math.max(previous, i + 2));
                }
              }}
              pageNumber={i + 1}
              {...productGridProps}
            />
          </Grid>
        </Grid>
      ))}
    </>
  );
};
